import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getFranchise = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/franchise/`, {
        headers: { Authorization: token }
    });
};

export const getFranchiseAccept = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/franchise/accept`, {
        headers: { Authorization: token }
    });
};

export const getFranchiseReject = async () => {
    const token = await cookie.get("token");
    return await axios.get(`${proxy}/franchise/reject`, {
        headers: { Authorization: token }
    });
};

export const acceptFranchise = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/franchise/accept/done/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const nonAcceptFranchise = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/franchise/accept/undone/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const rejectFranchise = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/franchise/reject/done/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const nonRejectFranchise = async (id) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/franchise/reject/undone/${id}`, {}, {
        headers: { Authorization: token }
    });
};

export const hidefFranchise = async (id, formDate) => {
    const token = await cookie.get("token");
    return await axios.put(`${proxy}/franchise/hide/${id}`, formDate, {
        headers: { Authorization: token }
    });
};